import * as TYPES from './action-types.js';
import {POI__STOP_TYPE, POI__LIST_TYPE} from "./store.js";
import http from "../../utils/http";
import {baiduToMars, formattedDistance, marsToBaidu} from "../../utils";

const POI__STOP_TYPE_ON = POI__STOP_TYPE.on;
const POI__STOP_TYPE_OFF = POI__STOP_TYPE.off;

const POI__LIST_TYPE_AUTOCOMPLETE = POI__LIST_TYPE.autocomplete;
const POI__LIST_TYPE_SEARCH = POI__LIST_TYPE.search;

// 带有命名空间的操作名
const POI__SET_STOP_TYPE_ACTION = `poi/${TYPES.POI__SET_STOP_TYPE}`;
const POI__SET_PLACEHOLDER_ACTION = `poi/${TYPES.POI__SET_PLACEHOLDER}`;
const POI__SET_LIST_TYPE_ACTION = `poi/${TYPES.POI__SET_LIST_TYPE}`;
const POI__SET_SEARCHING_POINT_ACTION = `poi/${TYPES.POI__SET_SEARCHING_POINT}`;

export function PoiService(context) {
	const dispatch = context.$store.dispatch;
	function setStopType(type) {
		dispatch(POI__SET_STOP_TYPE_ACTION, type);
		dispatch(POI__SET_PLACEHOLDER_ACTION, type);
	}
	function setListType(type) {
		dispatch(POI__SET_LIST_TYPE_ACTION, type);
	}
	function setPoiSearching(payload) {
		context.$MapService.setStatePoiSearching(payload);
	}
	function fetchNearStops(params) {
		setPoiSearching(true);
		const {lng, lat} = params || {};
		const marsPoint = baiduToMars(lng, lat);
		const areaId = _getAreaId();
		return http.post('/order/getNearStop', Object.assign({lineId: areaId}, params, marsPoint)).then((res) => {
			return Array.from(res).map(row => {
				const {
					id,
					name,
					lng,
					lat,
					distance = 0
				} = row;
				const {lng: _lng, lat: _lat} = marsToBaidu(lng, lat);
				let {text, unit} = formattedDistance(distance);
				return {
					name,
					point: new BMapGL.Point(_lng, _lat),
					id,
					distance,
					distanceText: text,
					distanceUnit: unit,
					lng: _lng,
					lat: _lat
				};
			});
		});
	}
	function fetchHistoryStops(params) {
		return http.post('/order/getHisStop', params);
	}
	function getTestSessionKey() {
		return context.$AppService.isTestMobile() ? 'hexinkey123456' : '';
	}
	// function fetchPoiList({query, region, sessionId}) {
	// 	return http.get(`/poi?query=${query}&region=${region}&sessionId=${sessionId}`).then((data) => {
	// 		let {results = []} = data || {};
	// 		return results;
	// 	});
	// }
	// 区域主键id:baseLineId, 城市id:cityId, 纬度:lat, 经度:lng, 关键字:query, 城市名字:region, 用户sessionId:sessionId, disabledPoi禁用poi点
	function fetchStopPoiList({baseLineId, cityId, lat, lng, query, region, sessionId, disabledPoi = false, ...extra}) {
		let marsPos = baiduToMars(lng, lat);
		return http.get(`/stopAndPoi?baseLineId=${baseLineId}&cityId=${cityId}&lat=${marsPos.lat}&lng=${marsPos.lng}&region=${region}&sessionId=${sessionId}&query=${query}`, {params: extra}).then((data) => {
			const {type, stopList = [], jsonObject = {}} = data || {};
			const {results: list = []} = jsonObject || {};
			if (type === 0) { // 区域内搜索的站点
				console.log('区域内搜索的站点');
				context.$PoiService.setListTypeSearch();
				return stopList.map(item => {
					const pos = marsToBaidu(item.lng, item.lat);
					const {text, unit} = formattedDistance(item.distance || 0);
					item.distanceText = text || '';
					item.distanceUnit = unit || '';
					return {
						...item,
						...{
							lng: pos.lng,
							lat: pos.lat,
							location: {
								lng: pos.lng,
								lat: pos.lat
							}
						}
					};
				});
			} else if (type === 1 && !disabledPoi) { // 地图搜索的poi
				console.log('地图搜索的poi');
				context.$PoiService.setListTypeAutocomplete();
				let [userLng, userLat] = _getUserPos() || [];
				let userPoint = (userLng && userLat) ? context.$MapService.createPoint(userLng, userLat) : null;
				return Array.from(list).map((item) => {
					let {address = '', location = {}} = item || {};
					let type = address.includes(';') ? 1 : 0;
					if (type === 1) {
						address = (address || '').split(';').map(p => p.trim()).filter(p => !!p);
					}
					let data = {type, address};
					let {lng: _lng, lat: _lat} = location || {};
					const {lng, lat} = marsToBaidu(_lng, _lat);
					if (lng && lat && userPoint) {
						let pointTo = context.$MapService.createPoint(lng, lat);
						let distance = context.$MapService.getPointDistance(userPoint, pointTo);
						let {text, unit} = formattedDistance(distance);
						data.distanceText = text;
						data.distanceUnit = unit;
						data.distance = distance;
					}
					return Object.assign({}, item, data);
				});
			} else {
				return [];
			}
		});
	}
	function _getStopType() {
		return context.$store.state.poi.stopType;
	}
	function _getListType() {
		return context.$store.state.poi.listType;
	}
	function _getAreaId() {
		return context.$store.state.home.areaId;
	}
	function isStopTypeOn() {
		return _getStopType() === POI__STOP_TYPE_ON;
	}
	function isStopTypeOff() {
		return _getStopType() === POI__STOP_TYPE_OFF;
	}
	function _getUserPos() {
		return context.$store.state.map.dataSource.userPos;
	}
	function _getAreaCenterPos() {
		return context.$store.state.map.dataSource.areaCenterPos;
	}
	function _getOnStop() {
		return context.$store.state.map.dataSource.onStop;
	}
	function _getOffStop() {
		return context.$store.state.map.dataSource.offStop;
	}
	return {
		/**
		 * 跳转至poi页面
		 * @param params
		 */
		turnToPoiView: (params, query = {}) => {
			context.$router.push({
				name: 'Poi',
        query,
				params
			});
		},
		/**
		 * 设置poi页面的搜索站点类型：上车站/下车站
		 * @param {string} type
		 * @return {Promise<any>}
		 */
		setStopType,
		/**
		 * 设置poi页面的搜索站点类型为上车站
		 * @return {void}
		 */
		setStopTypeOn: () => setStopType(POI__STOP_TYPE_ON),
		/**
		 * 设置poi页面的搜索站点类型为下车站
		 * @return {void}
		 */
		setStopTypeOff: () => setStopType(POI__STOP_TYPE_OFF),
		/**
		 * 是否是上车站poi页面
		 * @return {boolean}
		 */
		isStopTypeOn,
		/**
		 * 是否是下车站poi页面
		 * @return {boolean}
		 */
		isStopTypeOff,
		/**
		 * 设置poi列表类型
		 * @param {string} type - 类型：autocomplete: 自动联想，search：后台搜索
		 * @return {void}
		 */
		setListType,
		/**
		 * 设置poi列表类型为自动联想
		 */
		setListTypeAutocomplete: () => setListType(POI__LIST_TYPE_AUTOCOMPLETE),
		/**
		 * 设置poi列表类型为后台搜索
		 */
		setListTypeSearch: () => setListType(POI__LIST_TYPE_SEARCH),
		/**
		 * 判断poi列表类型是否为自动联想
		 * @param listType
		 * @return {boolean}
		 */
		isListTypeAutocomplete: () => _getListType() === POI__LIST_TYPE_AUTOCOMPLETE,
		/**
		 * 判断poi列表类型是否为后台搜索
		 * @param listType
		 * @return {boolean}
		 */
		isListTypeSearch: () => _getListType() === POI__LIST_TYPE_SEARCH,
		/**
		 * 设置后台搜索坐标
		 * @param {number} lng
		 * @param {number} lat
		 * @return {Promise<any>}
		 */
		setSearchingPoint: (lng, lat) => dispatch(POI__SET_SEARCHING_POINT_ACTION, [lng, lat]),
		/**
		 * 定义请求附近站点参数
		 * @typedef {Object} nearStopsParam
		 * @property {number} lng
		 * @property {number} lat
		 * @property {number} [lineId]
		 * @property {string} [cityId]
		 * @property {string} [userId]
		 */
		/**
		 * 拉取附近站点
		 * @param {nearStopsParam} params
		 * @return {Promise<*>}
		 */
		fetchNearStops,
		/**
		 * 拉取历史站点
		 * @typedef {cityId: string, lineId: string, userId: string} hisStopsParam - 请求历史站点参数
		 * @param {hisStopsParam} params
		 * @return {Promise<AxiosResponse>}
		 */
		fetchHistoryStops,
		/**
		 * 获取poi默认推荐列表
		 * @return {*[]}
		 */
		async fetchRecommend(areaId, extra = {}) {
			let {id: onStopId} = _getOnStop() || {};
			let {id: offStopId} = _getOffStop() || {};
			// 上车站推荐附近站点
			if (isStopTypeOn()) {
				// 优先使用用户当前位置，其次使用后台配置的推荐位置
				let pos = _getUserPos();
				if (pos) {
					try {
						const list = await fetchNearStops({
							lng: pos[0],
							lat: pos[1],
              ...(areaId ? {lineId: areaId}: {}),
							...extra
						});
						setPoiSearching(false);
						if (list) {
							setListType(POI__LIST_TYPE_SEARCH);
							return list.filter(p => p.id !== offStopId);
						}
					} catch (e) {
						console.log('获取上车站推荐列表失败', e, _getAreaCenterPos());
					} finally {
						setPoiSearching(false);
					}
				}
				setListType(POI__LIST_TYPE_AUTOCOMPLETE);
				return [];
			}
			// 下车站推荐历史站点
			if (isStopTypeOff()) {
				try {
					const list = await fetchHistoryStops({
						lineId: areaId? areaId: _getAreaId(),
						...extra
					});
					setPoiSearching(false);
					if (list) {
						setListType(POI__LIST_TYPE_SEARCH);
						return list.map(p => {
							const {lng, lat} = p || {};
							if (!lng || !lat) {
								return null;
							}
							const {lng: _lng, lat: _lat} = marsToBaidu(lng, lat);
							let point = new BMapGL.Point(_lng, _lat);
							return {
								...p,
								...{
									lng: _lng,
									lat: _lat,
									point
								}
							};
						}).filter(p => !!p && p.id !== onStopId);
					}
				} catch (e) {
					console.log('获取下车推荐列表失败', e);
				}
				setListType(POI__LIST_TYPE_AUTOCOMPLETE);
				return [];
			}
			setListType(POI__LIST_TYPE_AUTOCOMPLETE);
			return [];
		},
		fetchPoiList(query, areaId, disabledPoi = false, extra = {}) {
			// https://dev.maas.chelaile.net.cn/xygjclient/reactive/client/poi?query=妇幼&region=佛山&sessionId=1234
			let currentAreaId = context.$RunService.getCurrentAreaId();
			let region = context.$AppService.getCityName();
			let cityId = context.$AppService.getCityId();
			let {lng, lat} = context.$MapService.getUserPos();
			let sessionId = context.$UserService.getSessionId() || getTestSessionKey();
			return fetchStopPoiList({
				baseLineId: currentAreaId,
				cityId,
				lng: lng || '',
				lat: lat || '',
				query,
				region,
				sessionId,
        ...(areaId ? {baseLineId: areaId}: {}),
        disabledPoi,
				...extra
			});
		}
	};
}

export function install(Vue, context) {
	Vue.prototype.$PoiService = PoiService(context);
}
